/** PURE_IMPORTS_START _WebSocketSubject PURE_IMPORTS_END */
import { WebSocketSubject } from './WebSocketSubject';
export function webSocket(urlConfigOrSource) {
    return new WebSocketSubject(urlConfigOrSource);
}
//# sourceMappingURL=webSocket.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/internal/observable/dom/webSocket.js
// module id = 545
// module chunks = 18